import React from "react";

import TimelineCommon, {
  type TimelineAttachment,
  TimelineGroupped,
  type TimelineGrouppedProps,
  type TimelineItemInfo,
  type TimelineProps as TimelinePropsCommon
} from "@common/controls/Timeline/component";

import ActivityCommon, { type ActivityItem, type ActivityProps } from "@common/components/Activity/component";
import TransactionActivity from "@common/components/Activity/Transaction";

export { TimelineGroupped, type TimelineAttachment, type TimelineGrouppedProps, type TimelineItemInfo };

export type TimelineProps = TimelinePropsCommon & {};
const Timeline = (props: TimelineProps) => <TimelineCommon {...props} />;
export default Timeline;

export { TransactionActivity, type ActivityItem, type ActivityProps };
export const Activity = (props: Omit<ActivityProps<any>, "context">) => <ActivityCommon {...props} />;
